import React from "react";
import EmberField from "@/components/EmberField";
import { ArrowRight, Flame, TrendingUp, Coins, Users } from "lucide-react";

const steps = [
  {
    n: "01",
    icon: Coins,
    title: "You send dead coins",
    body: "Any token, any supported chain. Copy our treasury wallet, send what you've got — even unsellable shit. Your tx is logged with a USD snapshot via CoinGecko.",
  },
  {
    n: "02",
    icon: Flame,
    title: "3% fee cremates sellable dust",
    body: "A 3% transaction fee on every $QUODUST trade on Pons routes directly into the treasury. We swap sellable donations and the fee proceeds via 1inch / Jupiter / CowSwap, with a minimum-value threshold so gas doesn't eat the burn.",
  },
  {
    n: "03",
    icon: TrendingUp,
    title: "Buy & hardwire Quotrons",
    body: "That firewood funds Quotrons terminals on Robinhood Chain. Each hardwired terminal prints tokenized-stock yield onchain: NVDA · TSLA · AAPL · SPY. Receipts are chain-native and public — the whole inventory is visible on the Treasury page.",
  },
  {
    n: "04",
    icon: Users,
    title: "Yield → $QUODUST holders",
    body: "Monthly: we take the $QUODUST holder snapshot directly on Robinhood Chain (chain id 4663) and distribute the Quotrons yield pro-rata. Donors also earn $QUODUST airdrops weighted by USD donated.",
  },
];

export default function HowItWorks() {
  return (
    <div className="relative">
      <section className="relative overflow-hidden surface-grain">
        <EmberField count={20} />
        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 pt-14 pb-10">
          <div className="text-xs uppercase tracking-widest text-[#FFC940]">the flywheel</div>
          <h1 className="mt-2 font-display text-4xl sm:text-5xl lg:text-6xl font-black leading-tight">
            dust in. <span className="ember-text">yield out.</span>
          </h1>
          <p className="mt-4 max-w-2xl text-stone-300">
            Four moves, one survival circuit. We don't invent a token economy, we route real
            tokenized-stock yield from Robinhood Chain back to the people who got burned.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 sm:px-6 pb-14">
        <div className="grid md:grid-cols-2 gap-4">
          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={i}
                data-testid={`flywheel-step-${i + 1}`}
                className="relative rounded-xl border border-[#3A2E1C] bg-[#141008] p-6 hover:border-[#FFAB00]/50 transition-all"
              >
                <div className="flex items-start gap-4">
                  <div className="flex items-center justify-center w-12 h-12 rounded-md border border-[#FFAB00]/40 bg-[#1E1810]">
                    <Icon className="w-5 h-5 text-[#FFC940]" />
                  </div>
                  <div>
                    <div className="text-xs mono text-stone-500">step {s.n}</div>
                    <div className="font-display text-xl font-bold">{s.title}</div>
                  </div>
                </div>
                <p className="mt-4 text-sm text-stone-300 leading-relaxed">{s.body}</p>
                {i < steps.length - 1 && (
                  <ArrowRight className="hidden md:block absolute -right-5 top-1/2 -translate-y-1/2 w-6 h-6 text-[#FFAB00]/60" />
                )}
              </div>
            );
          })}
        </div>

        <div className="mt-10" />
      </section>
    </div>
  );
}
